// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"2f0ffb11","977":"f5a8ccaa"}[chunkId] + ".chunk.js";
};